<script lang="ts" setup>
import { Text } from '~ds/components/ui/typography';

/** `caption` is a quiet second line under the name, e.g. that the account is a personal classroom. */
interface Props {
  schoolName: string;
  caption?: string;
  nameWeight?: 'normal' | 'semibold';
}

const props = withDefaults(defineProps<Props>(), {
  caption: '',
  nameWeight: 'semibold',
});

const schoolInitials = computed(() =>
  props.schoolName
    .replace(/\(.*?\)/g, '')
    .split(' ')
    .filter(word => word.length > 0)
    .slice(0, 2)
    .map(word => word[0]?.toUpperCase() ?? '')
    .join(''),
);
</script>

<template>
  <span class="flex min-w-0 items-center gap-3">
    <span
      class="flex items-center justify-center rounded-full size-8 shrink-0 bg-brand-pink"
      data-testid="schools-sidebar-school-initials"
    >
      <Text
        as="span"
        size="sm"
        weight="semibold"
        class="text-foreground"
      >
        {{ schoolInitials }}
      </Text>
    </span>
    <span class="flex min-w-0 flex-col text-left">
      <Text
        as="span"
        :weight="nameWeight"
        class="truncate text-foreground"
        data-testid="schools-sidebar-school-name"
      >
        {{ schoolName }}
      </Text>
      <Text
        v-if="caption"
        as="span"
        size="sm"
        class="truncate text-muted-foreground"
        data-testid="schools-sidebar-school-caption"
      >
        {{ caption }}
      </Text>
    </span>
  </span>
</template>
